import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

let baseHost
if (process.env.NODE_ENV === 'dev') {
  baseHost = 'http://127.0.0.1:6174/api'
} else if (process.env.NODE_ENV === 'production') {
  baseHost = 'https://eatsonfeets.herokuapp.com/api'
} else if (process.env.NODE_ENV !== 'test') {
  baseHost = process.env.API_URL || 'https://eatsonfeets.herokuapp.com/api'
} else {
  baseHost = 'http://127.0.0.1:6174/api'
}

axios.defaults.baseURL = `${baseHost}`
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.Accept = 'application/json'
axios.defaults.headers['Access-Control-Allow-Origin'] = '*'

const authToken = localStorage.getItem('authToken')
if (authToken) {
  axios.defaults.headers.common.Authorization = `JWT ${authToken}`
}

export default {
  async getLoginCode(email) {
    const response = await Vue.axios.get(`/login/${email}`)
    return response
  },

  async postLoginCode(email, authcode) {
    const response = await Vue.axios.post('/login', {
      email,
      authcode
    })

    const token = response && response.data && response.data.token ? response.data.token : null
    localStorage.setItem('authToken', token)
    axios.defaults.headers.common.Authorization = `JWT ${token}`

    return response
  },

  async signUp(email, options) {
    const response = await Vue.axios.post(`/signup/${email}`, options)
    return response
  },

  async getRegions() {
    const response = await Vue.axios.get('/regions')
    return response
  },

  async getChapters() {
    const response = await Vue.axios.get('/chapters')
    return response
  },

  async getNewsArticles() {
    const response = await Vue.axios.get('/newsarticles')
    return response
  }

}
